import { useToast } from '@/components/ui/toast'
import { useLocaleStore } from '@/store/localStore'

const { toast } = useToast()

const translations = {
  en: {
    error: 'Error',
    genericError: 'An unexpected error occurred. Please try again.',
    success: 'Success',
    genericSuccess: 'The action was completed successfully.',
    saveSuccess: 'Changes have been saved successfully.',
    deleteSuccess: 'The entry has been deleted successfully.',
    createSuccess: 'The entry has been created successfully.'
  },
  de: {
    error: 'Fehler',
    genericError: 'Leider ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    success: 'Erfolg',
    genericSuccess: 'Die Aktion wurde erfolgreich ausgeführt.',
    saveSuccess: 'Die Änderungen wurden erfolgreich gespeichert.',
    deleteSuccess: 'Der Eintrag wurde erfolgreich gelöscht.',
    createSuccess: 'Der Eintrag wurde erfolgreich erstellt.'
  },
  fr: {
    error: 'Erreur',
    genericError: "Une erreur inattendue s'est produite. Veuillez réessayer.",
    success: 'Succès',
    genericSuccess: "L'action a été effectuée avec succès.",
    saveSuccess: 'Les modifications ont été enregistrées avec succès.',
    deleteSuccess: "L'entrée a été supprimée avec succès.",
    createSuccess: "L'entrée a été créée avec succès."
  }
}

const getTranslation = (key: keyof typeof translations.en): string => {
  const localeStore = useLocaleStore()
  const locale = localeStore.getLocale
  return translations[locale as keyof typeof translations]?.[key] || translations.en[key]
}

export const genericErrorToast = (message?: string) => {
  toast({
    title: getTranslation('error'),
    description: message || getTranslation('genericError'),
    variant: 'destructive'
  })
}

export const genericSuccessToast = () => {
  toast({
    title: getTranslation('success'),
    description: getTranslation('genericSuccess'),
    variant: 'success'
  })
}

export const saveSuccessToast = () => {
  toast({
    title: getTranslation('success'),
    description: getTranslation('saveSuccess'),
    variant: 'success'
  })
}

export const deleteSuccessToast = () => {
  toast({
    title: getTranslation('success'),
    description: getTranslation('deleteSuccess'),
    variant: 'success'
  })
}

export const createSuccessToast = () => {
  toast({
    title: getTranslation('success'),
    description: getTranslation('createSuccess'),
    variant: 'success'
  })
}
